module.exports = __webpack_public_path__ + "img/2@3x.4415e89a.png";